import {Injectable} from '@angular/core';
import {NgbDatepickerI18n, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '../shared/translate.pipe';

const I18N_VALUES = {
    weekdays: [
      'date.dayOfWeek.short.d1', 
      'date.dayOfWeek.short.d2', 
      'date.dayOfWeek.short.d3', 
      'date.dayOfWeek.short.d4', 
      'date.dayOfWeek.short.d5', 
      'date.dayOfWeek.short.d6', 
      'date.dayOfWeek.short.d0'
    ],
    months: [
      'date.month.short.m0', 
      'date.month.short.m1', 
      'date.month.short.m2', 
      'date.month.short.m3', 
      'date.month.short.m4', 
      'date.month.short.m5', 
      'date.month.short.m6', 
      'date.month.short.m7', 
      'date.month.short.m8', 
      'date.month.short.m9', 
      'date.month.short.m10', 
      'date.month.short.m11'
    ],
  };

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private translate: TranslatePipe) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return this.translate.transform(I18N_VALUES.weekdays[weekday - 1]);
  }
  getMonthShortName(month: number): string {
    return this.translate.transform(I18N_VALUES.months[month - 1]);
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}


// WEBPACK FOOTER //
// ./ts/app/activity-calendar/datepicker-i18n.ts